import { inject, Injectable } from "@angular/core";
import { ECompanyLevels } from "../enums/Levels.enum";
import { ELocalStorage } from "@core/enums/LocalStorage.enum";
import { LocalService } from "@core/services/local-storage.service";

@Injectable({
  providedIn: "root",
})
export class CompanyPermissionService {
  _localStorageService = inject(LocalService);

  companyRoles = Object.values(ECompanyLevels);

  get myData() {
    return this._localStorageService.getData(ELocalStorage.USER);
  }

  checkPermission() {
    const userAccess = this.myData?.role?.level as ECompanyLevels;

    return this.companyRoles.includes(userAccess);
  }
}
